import ConfigService from "./ConfigService";
import {fetch as Fetch} from "whatwg-fetch";
import {execute} from "./CallbackService";

class Client {
    fetch(url = '', fetchOptions = {}, retry = true) {
        const options = fetchOptions || {};
        const jwt = ConfigService.jwt();
        const headers = {Authorization: 'Bearer ' + jwt};
        const presetHeaders = options.headers || {};
        options.headers = Object.assign(presetHeaders, headers);

        return Fetch(url, options)
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    if (res.status === 401 && retry) {
                        return execute(ConfigService.authFailureCallback, () => {
                            return this.fetch(url, fetchOptions, false);
                        });
                    } else {
                        throw Error('Connection error');
                    }
                }
            })
            .then(json => {
                return json;
            });
    }
}

const JWTClient = new Client();
export default JWTClient;



// WEBPACK FOOTER //
// ./services/JWTClient.js